import React from 'react'
import ProductsPage from './ProductsPage'

const Categories = () => {
  return <ProductsPage pageType="categories" />
}

export default Categories
